// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const tablePaginatorConstants = {
  page: 'Page',
  of: 'of',
  showingResults: 'Showing Results',
};
